module.exports = __webpack_public_path__ + "img/Ansible.489c04a.svg";